import App from './AppContainer';
export default App;